export const STORAGE_KEYS = {
  REFRESH_TOKEN: 'refresh-token',
  ACCESS_TOKEN: 'access-token',
  GUEST_ID: 'guest-id',

  I18N_LNG: 'i18nextLng',
}
